import App from './App.svelte';
import AbstractID from './AbstractID';
import { loadConfiguration } from './AppConfiguration';
import { installNumberInputWheelGuard } from './numberInputWheelGuard';

// Before any form exists: a wheel over a focused number field would otherwise change its value.
installNumberInputWheelGuard(document);

// The configuration is an authenticated read, so it is only asked for once `initialize()` has
// resolved to an administrator's session — on every other outcome the page is already leaving
// for AbstractID, and the request would only fail on its way out.
if (AbstractID.initialize()) {
  loadConfiguration();
}

const app = new App({
  target: document.getElementById('app')
});

export default app;
